import React from 'react';
import { FaLock, FaLockOpen } from 'react-icons/fa';

export function LockUser({
  isLocked,
  updateUserIsLockedMethod,
}: {
  isLocked: boolean;
  updateUserIsLockedMethod: (checked: boolean) => void;
}): JSX.Element {
  return (
    <div className="edit-user-modal__form-group">
      {isLocked && (
        <div className={'warning'}>
          If you unlock a courier you need to make sure they are enrolled in
          Dipps. Otherwise they won't get payed.
        </div>
      )}
      <label>
        <span className="edit-user-modal__form-label" />
        <div className="edit-user-modal__form-checkbox">
          <input
            type="checkbox"
            name="isLocked"
            checked={isLocked}
            onChange={event => updateUserIsLockedMethod(event.target.checked)}
          />
          {isLocked && (
            <>
              <span className="edit-user-modal__form-lock-icon">
                <FaLock />
              </span>
              &nbsp;
              <span>Locked</span>
            </>
          )}
          {!isLocked && (
            <>
              <span className="edit-user-modal__form-lock-icon">
                <FaLockOpen />
              </span>
              &nbsp;
              <span>Unlocked</span>
            </>
          )}
        </div>
      </label>
    </div>
  );
}
